import { Directive, HostListener, ElementRef, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { markFormAsTouched } from '../reactive-forms/forEachElementInForm';

@Directive({
  selector: '[ccScrollToFirstInvalidField]'
})
export class ScrollToFirstInvalidFieldDirective {
  @Input() private formGroup: FormGroup;

  constructor(private el: ElementRef) {}

  @HostListener('submit')
  onFormSubmit() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.ng-invalid');
    if (invalidElements.length > 0) {
      const el = this.findTheMostTopElement(invalidElements);

      markFormAsTouched(this.formGroup);

      el.focus();
      el.scrollIntoView({ block: 'center', inline: 'center', behavior: 'smooth' });
    }
  }

  findTheMostTopElement(elements: NodeList): HTMLElement {
    const array = Array.from(elements) as [HTMLElement];

    array.sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top);

    return array[0];
  }
}
